import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import { TextError } from '.';
import { formatPhone, normalizePhoneInput, phoneCaretPosition } from '../../../utils/phone';

export function PhoneInput(props) {
    const { label, name, placeholder, optional, ...rest } = props;
    return (
        <>
            {label && (
                <label htmlFor={name}>
                    {label}{' '}
                    {!optional && (
                        <sup>
                            <FontAwesomeIcon icon={faAsterisk} />
                        </sup>
                    )}
                </label>
            )}
            <Field name={name}>
                {
                    // These props are coming from the Formik Field compoenent and it contains: field, form, meta
                    (props) => {
                        const { field, form, meta } = props;
                        // Formats as "+1 XXX-XXX-XXXX" like the old react-input-mask did, but a leading 1 or +1 is
                        // read as the country code instead of filling the first area-code slot (+11 leads).
                        const handleChange = (event) => {
                            const input = event.target;
                            let raw = input.value;
                            let caret = input.selectionStart ?? raw.length;
                            const previous = field.value ?? '';
                            const { inputType } = event.nativeEvent;
                            // Deleting only a dash would leave the digits unchanged and the dash would come straight
                            // back, so Backspace/Delete removes the digit on the far side of it instead, as the old
                            // mask did.
                            const onlyDashDeleted = normalizePhoneInput(raw) === normalizePhoneInput(previous);
                            if (
                                inputType === 'deleteContentBackward' &&
                                caret > 0 &&
                                previous[caret] === '-' &&
                                onlyDashDeleted
                            ) {
                                raw = raw.slice(0, caret - 1) + raw.slice(caret);
                                caret -= 1;
                            } else if (
                                inputType === 'deleteContentForward' &&
                                previous[caret] === '-' &&
                                onlyDashDeleted
                            ) {
                                raw = raw.slice(0, caret) + raw.slice(caret + 1);
                            }
                            const formatted = formatPhone(normalizePhoneInput(raw));
                            const position = phoneCaretPosition(raw, caret, formatted);
                            // Write the value and cursor before Formik re-renders: React then finds the DOM already
                            // matching and leaves the cursor alone, so a fast next key lands where the visitor is typing.
                            input.value = formatted;
                            input.setSelectionRange(position, position);
                            form.setFieldValue(field.name, formatted);
                        };
                        return (
                            <>
                                <input
                                    className={`form-control phone_input ${meta.error && meta.touched ? 'border-error' : ''}`}
                                    id={name}
                                    name={field.name}
                                    value={field.value ?? ''}
                                    onChange={handleChange}
                                    onBlur={field.onBlur}
                                    {...rest}
                                    placeholder={placeholder ? placeholder : '+1 999-999-9999'}
                                />
                            </>
                        );
                    }
                }
            </Field>
            <ErrorMessage name={name} component={TextError} />
        </>
    );
}

export default PhoneInput;
